export default {
  resorder_issue_details: "تفاصيل المشكلة",
  resback_to_orders: "العودة للطلبات",
  resissue_report_id: "رقم البلاغ",
  resreported_on: "تاريخ الإبلاغ",

  resissue_information: "معلومات المشكلة",
  resissue_type: "نوع المشكلة",
  resmissing_items: "عناصر مفقودة",
  resdamaged_products:"المنتجات التالفة",
  resdamaged_items: "عناصر تالفة",
  reswrong_items: "عناصر خاطئة",

  resselect_product: "اختر المنتج",
  resdescription: "الوصف",
  resdescribe_issue: "اشرح المشكلة...",

  resadd_photos: "إضافة صور",
  ressubmit_issue: "إرسال المشكلة",

  ressupplier_response: "رد المورد",
  resaction: "الإجراء",
  resrefund: "المبلغ المسترجع",
  resnotes: "ملاحظات",

  resrecent_activity: "النشاط الأخير",
  resissue_reported: "تم الإبلاغ",
  resissue_under_review: "قيد المراجعة",
  reswaiting_supplier: "بانتظار رد المورد",
  resissue_resolved: "تم الحل",

  resneed_help: "تحتاج مساعدة؟",
  rescontact_support: "اتصل بالدعم",

  resdescribe_issue_error: "يرجى وصف المشكلة",
  resselect_product_error: "يرجى اختيار منتج واحد على الأقل",
  resissue_failed: "فشل إرسال المشكلة",
};